import React from 'react';
import {Nav, Tab} from '@deere/ux.uxframe-react';
import {Proposal} from './../Proposal/index';
import {ThirdParties} from './../ThirdParties/index';
import {Review} from './../Review/index';
import {
    duplicateEmailMobileSignerError,
    duplicateEmailMobileSignerErrorLegalCompliance,
    duplicateSignerError,
    mandatoryFieldsForSignerError
} from '../Constants/constants';
import {FormattedMessage} from 'react-intl';
import {CreateEnvelopeHeader} from './CreateEnvelopeHeader';
import {SignerValidation} from './SignerValidation';
import {validateDuplicateSignersMethods, validateDuplicateEmailMobileSigners} from '../../../shared/utility';
import PropTypes from 'prop-types';


export class Envelope extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePane: 'proposal-details',
            bundleData: this.props.location.state,
            signersDetails: [],
            selectedDocumentDetails: [],
            showMandatoryFieldsError: 'invisible',
            showDuplicationError: 'invisible',
            showDuplicateEmailMobileError: 'invisible',
            errorMessage: 'Error',
            errorMessageCompliance: 'Error',
            duplicateSignerSet: [],
            duplicateEmailMobileNoSet: [],
            disableEnvelopeTabs: false,
            duplicateEmailMobileCheckSuppress: false,
            signersInSelectedDocuments: new Set()
        };

        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.getSignerDetails = this.getSignerDetails.bind(this);
        this.getDocumentList = this.getDocumentList.bind(this);
        this.disableCreateEnvelopeTabs = this.disableCreateEnvelopeTabs.bind(this);
        this.validateMandatoryFields = this.validateMandatoryFields.bind(this);
        this.handleCBCheckBox = this.handleCBCheckBox.bind(this);
        this.setDuplicateEmailMobileErrorState = this.setDuplicateEmailMobileErrorState.bind(this);
        this.setDuplicateEmailMobileErrorState2 = this.setDuplicateEmailMobileErrorState2.bind(this);
        this.setDuplicateSignersErrorState = this.setDuplicateSignersErrorState.bind(this);
        this.setDuplicateSignersErrorState2 = this.setDuplicateSignersErrorState2.bind(this);
    }

    handleExpandClick() {
        this.setState((prevState) => ({
            expanded: !prevState.expanded
        }));
    }


    validateMandatoryFields(signersInfo) {
        if (signersInfo.length > 0) {
            for (const element of signersInfo) {
                if (
                    element['emailID'] === '' ||
                    element['phoneNumber'] === '' ||
                    element['emailID'] === null ||
                    element['phoneNumber'] === null
                ) {
                    this.setState({showMandatoryFieldsError: 'visible'});
                    this.setState({
                        errorMessage: mandatoryFieldsForSignerError
                    });
                    break;
                } else {
                    this.setState({showMandatoryFieldsError: 'invisible'});
                }
            }
        } else if (signersInfo.length === 0) {
            this.setState({showMandatoryFieldsError: 'invisible'});
        }
    }

    setDuplicateSignersErrorState(duplicateSigners, tempDuplicateSignersArray){
        this.setState({duplicateSignerSet: new Set(tempDuplicateSignersArray)});
        if (duplicateSigners.size > 0) {
            this.setState({showDuplicationError: 'visible'});
            this.setState({errorMessage: duplicateSignerError});
        } else if (duplicateSigners.size === 0) {
            this.setState({showDuplicationError: 'invisible'});
        }
    }

    setDuplicateSignersErrorState2(){
        this.setState({showDuplicationError: 'invisible'});
    }



    setDuplicateEmailMobileErrorState(duplicateEmailMobileNoSigners, tempDuplicateEmailMobileArray){
        this.setState({duplicateEmailMobileNoSet: new Set(tempDuplicateEmailMobileArray)});
        if (duplicateEmailMobileNoSigners.size > 0) {
            this.setState({showDuplicateEmailMobileError: 'visible'});
            this.setState({errorMessage: duplicateEmailMobileSignerError});
            this.setState({errorMessageCompliance: duplicateEmailMobileSignerErrorLegalCompliance});
        } else if (duplicateEmailMobileNoSigners.size === 0) {
            this.setState({showDuplicateEmailMobileError: 'invisible'});
        }
    }

    setDuplicateEmailMobileErrorState2(){
        this.setState({showDuplicateEmailMobileError: 'invisible'});
    }

    getSignerDetails = (signersInfo, suppressEmailMobileValidation) => {
        this.validateMandatoryFields(signersInfo);
        validateDuplicateSignersMethods(signersInfo,
            this.setDuplicateSignersErrorState,
            this.setDuplicateSignersErrorState2)
        validateDuplicateEmailMobileSigners(signersInfo,
            suppressEmailMobileValidation,
            this.setDuplicateEmailMobileErrorState,
            this.setDuplicateEmailMobileErrorState2);
        this.setState({
            signersDetails: signersInfo
        });
    }

    getDocumentList(docList) {
        this.setState({
            selectedDocumentDetails: docList
        });
        const signers = new Set()
        docList.forEach((doc) => {
            doc.documentSigners.forEach((signer) => {
                signers.add(signer)
            })
        })
        this.setState({ signersInSelectedDocuments: signers })
    }

    handleCBCheckBox() {
        this.getSignerDetails(this.state.signersDetails, true);
    }

    disableCreateEnvelopeTabs(tabStatus) {
        this.setState({
            disableEnvelopeTabs: tabStatus
        });
    }

    render() {
        return (
            <Tab.Container
                defaultActiveKey="proposal-details"
                id="left-tabs-example"
                onSelect={(key) => this.setState({activePane: key})}
                transition={false}
            >
                <CreateEnvelopeHeader disabled={this.state.disableEnvelopeTabs}/>

                <Nav
                    className="d-flex justify-content-left uxf-nav-tabs-medium"
                    variant="tabs"
                >
                    <Nav.Item>
                        <Nav.Link
                            disabled={this.state.disableEnvelopeTabs}
                            eventKey="proposal-details"
                        >
                            <FormattedMessage id={'labels.PROPOSAL_DETAILS'}/>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            disabled={this.state.disableEnvelopeTabs}
                            eventKey="third-parties"
                        >
                            <FormattedMessage id={'labels.ASSOCIATED_PARTIES'}/>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link
                            disabled={this.state.disableEnvelopeTabs}
                            eventKey="envelope-review"
                        >
                            <FormattedMessage id={'labels.ENVELOPE_REVIEW'}/>
                        </Nav.Link>
                    </Nav.Item>
                    {(this.state.activePane === 'third-parties' || this.state.activePane === 'envelope-review') && <SignerValidation
                        countryCode={this.state.bundleData.countryCode}
                        errorMessage={this.state.errorMessage}
                        errorMessageCompliance={this.state.errorMessageCompliance}
                        handleCBCheckBox={this.handleCBCheckBox}
                        showDuplicateEmailMobileError={this.state.showDuplicateEmailMobileError}
                        showDuplicationError={this.state.showDuplicationError}
                        showMandatoryFieldsError={this.state.showMandatoryFieldsError} />}
                </Nav>

                <Tab.Content>
                    <Tab.Pane className="h-100" eventKey="proposal-details">
                        <Proposal
                            bundleData={this.state.bundleData}
                            getDocumentList={this.getDocumentList}
                        />
                    </Tab.Pane>
                    <Tab.Pane className="h-100" eventKey="third-parties">
                        <ThirdParties
                            alfaDealerIdentifier={this.state.bundleData.alfaDealerIdentifier}
                            countryCode={this.state.bundleData.countryCode}
                            documentDetails={this.state.selectedDocumentDetails}
                            duplicateEmailMobileNoSet={this.state.duplicateEmailMobileNoSet}
                            duplicateSignerSet={this.state.duplicateSignerSet}
                            getSignerDetails={this.getSignerDetails}
                            quoteNumber={this.state.bundleData.quoteNumber}
                            signersInSelectedDocuments={this.state.signersInSelectedDocuments}
                        />
                    </Tab.Pane>
                    <Tab.Pane className="h-100" eventKey="envelope-review">
                        <Review
                            bundleNumber={this.state.bundleData.bundleNumber}
                            countryCode={this.state.bundleData.countryCode}
                            createdBy={this.state.bundleData.salesPersonName}
                            disableCreateEnvelopeTabs={this.disableCreateEnvelopeTabs}
                            documentDetails={this.state.selectedDocumentDetails}
                            duplicateEmailMobileNoSet={this.state.duplicateEmailMobileNoSet}
                            duplicateSignerSet={this.state.duplicateSignerSet}
                            financeProduct={this.state.bundleData.financeProduct}
                            primaryCustomerName={this.state.bundleData.primaryCustomer[0]}
                            quoteNumber={this.state.bundleData.quoteNumber}
                            showError={
                                this.state.showMandatoryFieldsError === 'invisible' &&
                                this.state.showDuplicationError === 'invisible' &&
                                this.state.showDuplicateEmailMobileError === 'invisible'
                            }
                            signersDetails={this.state.signersDetails}
                        />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        );
    }
}

Envelope.propTypes = {
    location: PropTypes.object.isRequired
}
